import { render, staticRenderFns } from "./LogoText.vue?vue&type=template&id=2ccb6682&"
import script from "./LogoText.vue?vue&type=script&lang=js&"
export * from "./LogoText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports